import { motion } from "framer-motion";
import { FileText, CheckCircle2, Banknote } from "lucide-react";

const steps = [
  {
    n: "01",
    icon: FileText,
    title: "Apply in Minutes",
    body: "60-second online application. No tax returns. Last 3 months of bank statements is all we need to start.",
  },
  {
    n: "02",
    icon: CheckCircle2,
    title: "Get Approved Fast",
    body: "Decisions in hours, not weeks. Soft pull only — your credit score isn't affected during pre-qualification.",
  },
  {
    n: "03",
    icon: Banknote,
    title: "Get Funded",
    body: "Sign your terms electronically. Funds wired to your business account — often the same day.",
  },
];

export default function HowItWorks() {
  return (
    <section id="how" data-testid="how-it-works-section" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-16 md:mb-24">
          <div className="text-xs tracking-[0.25em] uppercase font-bold text-gold mb-5">The Process</div>
          <h2 className="font-heading text-4xl md:text-5xl font-light text-white tracking-tighter">
            Three steps. Hours, not weeks.
          </h2>
          <p className="mt-6 text-white/60 text-lg max-w-2xl">
            Every step is designed to remove the friction banks create. Apply once.
            Get matched to the right product. Receive capital that actually moves your business.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {steps.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="trace-border bg-[#0A1326] p-8 md:p-10 group"
              data-testid={`step-${i + 1}`}
            >
              <div className="flex items-start justify-between">
                <s.icon className="w-8 h-8 text-gold" />
                <div className="number-ghost text-7xl md:text-8xl">{s.n}</div>
              </div>
              <h3 className="mt-8 font-heading text-2xl text-white">{s.title}</h3>
              <p className="mt-4 text-white/60 leading-relaxed">{s.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
